export default __webpack_public_path__ + "2b64c4e31905caa8a94343a9a82d86ad.glb";